import React, { useState } from 'react';
import { useDebounceCallback, useLocalStorage } from 'usehooks-ts'
import { useTranslation } from "react-i18next";

export const SortBar = ({ viewTypeName, direction, onSortChange }) => {
    const [viewType, setViewType] = useLocalStorage(viewTypeName, 'list')
    const [sortDirection, setSortDirection] = useState(direction);

    const { t } = useTranslation();

    const changeDirection = () => {
        let direction;
        switch (sortDirection) {
            case 'asc':
                direction = 'desc';
                break;
            case 'desc':
                direction = 'asc';
                break;
            default:
                direction = 'asc';  
                break;
        }
        setSortDirection(direction);
        onSortChange && onSortChange(direction);
    }

    return (
        <div className="sort-bar">
            <div className="sort-bar-group active">
            <span>{t('filtersModalButton.sort_by')}: &nbsp;</span>
                {sortDirection === 'desc'
                    ? <img className="sort-bar-icon" src="/images/icons/sortza.svg" alt="sort descending" onClick={changeDirection} />
                    : <img className="sort-bar-icon" src="/images/icons/sortaz.svg" alt="sort ascending" onClick={changeDirection} />
                }

            </div>
            { viewTypeName && <div className="sort-bar-group">
                <img className={`sort-bar-icon ${viewType === "list" ? 'active' : ''}`} src="/images/icons/list_view.svg" alt="list" onClick={() => setViewType('list')} />
                <img className={`sort-bar-icon ${viewType === "card" ? 'active' : ''}`} src="/images/icons/card_view.svg" alt="card" onClick={() => setViewType('card')} />
            </div> }
        </div>
    )
}

export const SearchBar = ({ onChange, placeholder = 'title', value='' }) => {
    const [searchText, setSearchText] = useState(value);
    const debounced = useDebounceCallback(onChange, 500)
    return (
        <div className="search-bar">
            <div className="icon-block">
                <img className="icon" src="/images/icons/search.svg" />
            </div>
            <div className="input-block">
                <input type="search" name="search" className="search-input" placeholder={placeholder} value={searchText}
                onChange={(e) => { setSearchText(e.target.value); debounced(e.target.value); }}/>
            </div>
        </div>
    )
}